export default __webpack_public_path__ + "static/media/cf.3166dd69.svg";